export default __webpack_public_path__ + "static/media/image11.f4951038.png";